import { Box, Stack, Text } from '@chakra-ui/react';
import { useParams } from 'react-router-dom';
import { getProjectData } from '../services/Projects.js';
import { useEffect, useState } from 'react';
import ProjectsPrimaryForm from './Projects/ProjectsPrimaryForm.js';

const EditProjectRecord = () => {

  const { alias } = useParams();
  const [insightTitle, setInsightTitle] = useState();

  useEffect(() => {
    const getBasicData = async () => {
      try {
        if (alias) {
          const result = await getProjectData(alias);

          if (result) {
            setInsightTitle(result?.data?.[0]?.title);
          }
        }
      } catch (error) {
        console.error('Error fetching project data:', error);
      }
    };

    getBasicData();
  }, [alias]);


  return (
    <Stack px="1.5rem" py={'1rem'} width={"100%"}>
      <Box>
        <Text fontSize={"18px"} fontWeight={"600"}>{insightTitle}</Text>
      </Box>
      <ProjectsPrimaryForm />
    </Stack>
  );
};

export default EditProjectRecord;